/**
* Videos Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Videos Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'videos-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.videos-slider' ).each( function( key, val ) {
        $( this ).find( '.slider' ).slick( {
          dots: false,
          arrows: true,
          prevArrow: $( this ).find( '.custom-prev-slide' )[0],
          nextArrow: $( this ).find( '.custom-next-slide' )[0],
          centerMode: true,
          centerPadding: '200px',
          slidesToShow: 1,
          draggable: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                centerPadding: '50px',
                slidesToShow: 1,
              },
            },
            {
              breakpoint: 500,
              settings: {
                centerPadding: '5px',
                slidesToShow: 1,
              },
            },
          ],
        } );

        $( this ).find( '.custom-prev-slide, .custom-next-slide' ).click( function() {
          console.log( $( val ).find( '.sprite-animation' ) );
          $( val ).find( '.sprite-animation' ).addClass( 'is-running' );

          setTimeout( function() {
            $( val ).find( '.sprite-animation' ).removeClass( 'is-running' );
          }, 1050 );
        } );

        const containerWidth = $( this ).find( '.inner-area' ).width();
        const activeSlideHeight = $( this ).find( '.slick-active' ).height();
        const activeSlideWidth = $( this ).find( '.slick-active' ).width();
        const activeSlide = $( this ).find( '.slick-active' )[0];
        const activeSlideScale = containerWidth / activeSlideWidth;
        const activeSlideScaleHeight = activeSlideHeight * activeSlideScale;

        if ( window.innerWidth > 1023 ) {
          // Create space for the large slide
          $( this ).find( '.spacer' ).height( activeSlideScaleHeight );

          const offsetHeight = $( this ).find( '.slider-wrapper' ).position().top - $( this ).find( '.spacer' ).position().top;

          $( this ).find( '.slick-active' ).css( {
            'transform': 'translateY( -' + ( offsetHeight ) + 'px ) scale(' + activeSlideScale + ')',
          } );

          window.scrollRefreshPriority--;
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top top',
              end: 'bottom 135%',
              refreshPriority: window.scrollRefreshPriority,
              scrub: 0,
              onLeave: ( x, y, z ) => {
                $( '.video-title' ).addClass( 'is-loaded' );
              },
              onEnterBack: ( x, y, z ) => {
                $( '.video-title' ).removeClass( 'is-loaded' );
              },
              // markers: true,
            },
          } );
          tl.to( activeSlide, {y: '0', scale: '1', ease: 'linear'}, 0 );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'videos-slider', COMPONENT );
} )( app );
